<template>

    <v-dialog v-model="dialog" max-width="400" persistent>
    
        <v-card>

            <v-card-title class="text-h5 pa-4 bg-red-lighten-5">
                <v-icon left class="mr-2">mdi-alert</v-icon>
                {{ title }}
            </v-card-title>
            
            <v-card-text class="pa-4">
                {{ message }}
            </v-card-text>
            
            <v-card-actions class="pa-4 pt-0">
                <v-spacer></v-spacer>
                <v-btn color="grey" variant="text" @click="cancelar">Cancelar</v-btn>
                <v-btn color="error" variant="flat" @click="confirmar" :loading="loading">
                    Confirmar
                </v-btn>
            </v-card-actions>

        </v-card>

    </v-dialog>

</template>

<script setup>

    import { ref, watch } from 'vue'

    const props = defineProps({

        modelValue: Boolean,
        title: {
            type: String,
            default: 'Confirmar Ação'
        },
        message: {
            type: String,
            default: 'Tem certeza?'
        }
    })

    const emit = defineEmits(['update:modelValue', 'confirm', 'cancel'])

    const dialog = ref(props.modelValue)
    const loading = ref(false)

    watch(() => props.modelValue, (val) => {
        dialog.value = val
    })

    watch(dialog, (val) => {
        emit('update:modelValue', val)
    })

    const confirmar = async () => {
        
        loading.value = true
        emit('confirm')
        setTimeout(() => {
            dialog.value = false
            loading.value = false
        }, 300)
    }

    const cancelar = () => {
        emit('cancel')
        dialog.value = false
    }
</script>